<template>
  <div>
    <div class="zpContHead">
      <div class="cont">
        <div class="imgs img">
          <a-carousel arrows autoplay>
            <div v-for="item in info.resources">
              <img :src="$imgUrl + item.path_name" alt="" />
            </div>
          </a-carousel>
        </div>
        <div class="box">
          <div class="title">{{ info.name }}</div>
          <div class="txt">{{ info.simple }}</div>
          <div class="txt1">
            活动报名时间：{{ info.start_time }}-{{ info.end_time }}
          </div>
          <div class="texts">
            <div class="text" v-if="info.price != 0">
              课程金额：<span>{{ info.price }}</span
              >元
            </div>
            <div class="text" v-if="info.price == 0">课程金额：免费</div>
            <div class="textBtn" @click="chakClick(info.url)">前往查看</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="listCont">
        <!-- <div class="headText">课程列表(15节)</div>
        <div class="kcList">
          <div class="kcLi">1.第一节课</div>
          <div class="kcLi">2.第二节课</div>
          <div class="kcLi">3.第三节课</div>
          <div class="kcLi">4.第四节课</div>
          <div class="kcLi">5.第四节课</div>
          <div class="kcLi">6.第四节课</div>
          <div class="kcLi">7.第四节课</div>
          <div class="kcLi">8.第四节课</div>
          <div class="kcLi">9.第四节课</div>
          <div class="kcLi">10.第四节课</div>
          <div class="kcLi">11.第四节课</div>
          <div class="kcLi">12.第四节课</div>
          <div class="kcLi">13.第四节课</div>
          <div class="kcLi">14.第四节课</div>
          <div class="kcLi">15.第四节课</div>
        </div> -->
        <div class="headText">课程图文介绍</div>
        <div class="kcCont" v-html="info.content"></div>
      </div>
      <div class="rightCont">
        <div class="cont" v-for="item in recommendlist">
          <div class="img">
            <img :src="$imgUrl + item.resources[0].path_name" />
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="box">
            <div class="txt">{{ item.start_time }}</div>
            <div class="money" v-if="item.price != 0">
              <span>￥</span>{{ item.price }}
            </div>
            <div class="money" v-if="item.price == 0">免费</div>
          </div>
        </div>
      </div>
      <Baoming v-if="bmShow" :id="id" @show="showJs" />
    </div>
  </div>
</template>

<script>
import Baoming from "../component/baoming.vue";

export default {
  components: {
    Baoming,
  },
  name: "",
  data() {
    return {
      info: {},
      recommendlist: [],
      bmShow: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.get();
  },
  methods: {
    chakClick(url){
      window.open(url);
    },
    showJs() {
      this.bmShow = false;
    },
    bmClick() {},
    get() {
      this.$get("/nozzle/web/train_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        this.info = res.data;
        for (let i = 0; i < res.data.length; i++) {
          const e = res.data[i];
          e.start_time = this.$moment(e.start_time).format("YYYY年MM月DD日");
        }
        this.recommendlist = res.recommendlist;
        this.info.end_time = this.$moment(this.info.end_time).format(
          "YYYY年MM月DD日"
        );
        this.info.start_time = this.$moment(this.info.start_time).format(
          "YYYY年MM月DD日"
        );
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.zpContHead {
  width: 100%;
  background-color: #fff;
  .cont {
    width: 1280px;
    margin: auto;
    display: flex;
    padding: 25px 0;
    .imgs {
      height: 350px;
      width: 600px;
      border-radius: 10px;
      overflow: hidden;
      img {
        height: 350px;
        width: 600px;
        object-fit: cover;
      }
    }
    .box {
      width: calc(100% - 600px);
      height: 350px;
      padding-left: 25px;
      box-sizing: border-box;
      position: relative;
      .title {
        font-weight: 600;
        font-size: 28px;
        margin-bottom: 15px;
      }
      .txt {
        font-size: 15px;
        text-indent: 2em;
        line-height: 150%;
        color: #333;
        margin-bottom: 5px;
      }
      .txt1 {
        font-size: 15px;
        line-height: 150%;
        color: #333;
        margin-bottom: 5px;
      }
      .texts {
        position: absolute;
        bottom: 15px;
        display: flex;
        align-items: center;
        .textBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          width: 80px;
          border-radius: 5px;
          background-color: #0a9cf0;
          color: #fff;
          cursor: pointer;
        }
      }
      .text {
        font-size: 16px;
        color: #666;
        margin-top: 10px;
        margin-right: 30px;
        span {
          font-weight: 600;
          color: #f00a0a;
          font-size: 18px;
          margin-right: 2px;
        }
      }
      .btn {
        position: absolute;
        bottom: 10px;
        left: 25px;
        background-color: #ec6e07;
        color: #fff;
        width: 140px;
        height: 45px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  display: flex;
  padding-top: 20px;
  .listCont {
    width: calc(100% - 280px);
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    .headText {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 15px;
    }
    .kcList {
      display: flex;
      flex-wrap: wrap;
      .kcLi {
        box-shadow: 0 0 4px 2px #ebebeb;
        width: calc(33.33% - 10px);
        margin-right: 15px;
        border-radius: 5px;
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        box-sizing: border-box;
        margin-bottom: 15px;
      }
      .kcLi:nth-child(3n) {
        margin-right: 0;
      }
    }
    .kcCont {
      .text {
        text-align: justify;
        line-height: 150%;
        text-indent: 2em;
        margin-bottom: 10px;
        color: #333;
      }
      .img {
        img {
          width: 100%;
          border-radius: 5px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .rightCont {
    width: 280px;
    padding-left: 20px;
    box-sizing: border-box;
    .ritTxt {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 15px;
    }
    .cont {
      border-radius: 10px;
      margin-bottom: 20px;
      overflow: hidden;
      background-color: #fff;
      .img {
        width: 100%;
        height: 260px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .name {
        margin-top: 10px;
        font-size: 15px;
        padding: 0 10px;
      }
      .box {
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        padding-bottom: 10px;
        color: #888;
        font-size: 13px;
        span {
          font-size: 12px;
        }
        .money1 {
          color: #f83f10;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
